import { IPathToPageIdMap } from '@move-frontend/contentful-routes';
import { AccountPageId } from './AccountPageId';

export const accountPagePathToPageIdMap: IPathToPageIdMap = {
	'/account/offers': AccountPageId.RewardOffers,
	'/account/details': AccountPageId.AccountDetails,
	'/account/change-password': AccountPageId.ChangePassword,
	'/account/my-vehicles': AccountPageId.Vehicles,
};
